
import 'jquery';
import 'bootstrap/js/dist/dropdown';

import { Utils } from "../include/utils";
import { Forms } from '../include/forms';
import { TagManager } from '../include/tagManager';
import { TelemetryClient } from '../include/telemetry';
import '../include/webVitalsObserver';

declare var grecaptcha: any;
declare var $respond: any;

/**
 * Clase para gestionar la configuracion de un campo autocomplete
 */
export class PageAbstract {

    utils = new Utils();
    tagManager: TagManager;

    recent_reservations_count: number = 0;

    /** constructor */
    constructor() {
        this.tagManager = new TagManager(this.utils);
        this.captureInitialCurrency();
        this.initTelemetry();
        // Trabajo absolutamente crítico: ninguno de estos listeners es necesario
        // para el primer render, así que se difiere todo lo posible.
        this.initCriticalAfterFirstPaint();
        this.initNonCriticalOnIdle();
    }

    /**
     * Inicializa el cliente de telemetría como singleton global
     */
    private initTelemetry(): void {
        (window as any).telemetry = TelemetryClient.getInstance();
    }

    /**
     * Registra la moneda inicial una sola vez por sesión de navegador.
     * Usa localStorage para que sobreviva recargas de página (el cambio de moneda
     * provoca un reload, pero el valor inicial ya quedó guardado).
     * La clave 'alk_initial_currency' nunca se sobreescribe una vez guardada.
     */
    private captureInitialCurrency(): void {
        const STORAGE_KEY = 'alk_initial_currency';
        if (localStorage.getItem(STORAGE_KEY)) return; // Ya fue capturada antes, no tocar

        const currentCurrency = this.utils.readCookie('currency');
        if (currentCurrency) {
            localStorage.setItem(STORAGE_KEY, currentCurrency.toUpperCase());
        }
    }

    /**
     * Inicializa trabajo ligero que debe estar disponible pronto tras el primer render,
     * pero no bloquea la carga inicial.
     */
    private initCriticalAfterFirstPaint() {
        this.scheduleIdle(() => {
            this.listenChangeCurrency();
            this.listeButtonUp();
            this.fixImgError();

            $('#domain').on('change', function () {
                window.location.href = $(this).val()?.toString() || '/';
            });

            $('#close-banner-promo').on('click', function () {
                $(this).parent().remove();
            });
        }, 300);
    }

    /**
     * Inicializa trabajo pesado/no crítico (formularios, cookies, chat, historial, etc.)
     * en un idle más lejano para liberar el main thread en HOME y LANDING.
     */
    private initNonCriticalOnIdle() {
        this.scheduleIdle(() => {
            this.listenLogin();
            this.submitRegistrarUsuario();
            this.showModalRegistrate();
            this.showModalForgot();
            this.ForgotListen();
            this.listeLogOut();
            this.listenCookies();
            this.listenGetLinkAlq();
            this.listenChat();
            this.getRecentReservations();

            // Cargar librerías pesadas sólo cuando se necesiten por primera vez.
            $('body').one('show.bs.dropdown', () => {
                import("scriptjs").then((module) => {
                    const $script = module.default;
                    $script("https://www.google.com/recaptcha/api.js", null!);
                });
            });
        }, 2000);
    }

    /**
     * Helper para ejecutar trabajo en requestIdleCallback cuando esté disponible
     * o con un pequeño timeout como fallback. Mantener simple (sin workers) en desktop.
     */
    private scheduleIdle(callback: () => void, timeout: number = 0) {
        const win: any = window;
        if (typeof win.requestIdleCallback === 'function') {
            win.requestIdleCallback(() => callback(), { timeout });
        } else {
            setTimeout(() => callback(), timeout);
        }
    }

    private getRecentReservations(): any[] {
        try {
            const name = this.utils.getSha1('recent_reservations');
            const _recent_reservations = this.utils.decompressEncodedURI(this.utils.readCookie(name) || '');
            const recent_reservations = JSON.parse(_recent_reservations || '[]');
            this.recent_reservations_count = recent_reservations.length;
            this.showRecentReservations();
            return recent_reservations;
        } catch (error) {
            console.error(`error en obtener la reserva function(getRecentReservations): '${error}'`);
            this.recent_reservations_count = 0;
        }
        return [];
    }

    private showRecentReservations() {
        if (this.recent_reservations_count > 0) {
            const navItem = $('#nav-list-reservation');
            navItem.removeClass('d-none');
            navItem.find('.badge').text(this.recent_reservations_count);
        }
    }

    protected addRecentReservations(reservation: { id: string }) {
        try {
            const recent_reservations = this.getRecentReservations();
            recent_reservations.push(reservation);
            const name = this.utils.getSha1('recent_reservations');
            const data_compress = this.utils.compressEncodedURI(JSON.stringify(recent_reservations));
            this.utils.createCookie(name, data_compress, 365, Domain);
            this.recent_reservations_count = recent_reservations.length;
        } catch (error) {
            console.error(`error en agregar la reserva function(addRecentReservations): '${error}'`);
            this.recent_reservations_count = 0;
        }
        this.showRecentReservations()
    }

    fixImgError() {
        $('img').on('error', function () {
            const img = $(this);
            if (img.hasClass('lazy')) return;
            img.parent('picture').find('source').remove();
            img.removeAttr('data-src');
            img.attr('src', 'https://img.alkilautos.com/40-35/0-0-tn3-NoImageApp.jpg');
            img.addClass('img-error');
        });
    }

    listenChat(time = 0) {
        if (typeof $respond !== 'undefined') {
            $respond.on('chat:sent', () => {
                this.tagManager.eventItemOnly('event_click_chat');
            });
        } else {
            if (time < 5) setTimeout(() => this.listenChat(time + 1), 100);
        }
    }

    listeButtonUp() {
        $(".top-ico").click(function () {
            $('html,body').animate({ scrollTop: 0 }, 200);
        });
    }

    listeLogOut() {
        let self = this;
        $(document).on('click', 'a[href="/logout/"]', function (event) {
            event.stopPropagation();
            event.preventDefault();
            let config = { dir: '/action/logout/', type: 'POST' }
            self.utils.deleteCookie('__tawkuuid', Domain);
            self.utils.jSONInfo(config, {}, function (data: any) {
                location.reload();
            });
        });
    }

    /**
     * Listener para abrir el modal de registrate
     */
    showModalRegistrate() {
        $("#btn-modal-registrate").on("click", function (event: any) {
            let modal = $('#modal-registrate');
            modal.modal().modal('show');
        });
    }

    showModalForgot() {
        $("#btn-forgot").on("click", function (event: any) {
            let modal = $('#modal-forgot');
            modal.modal().modal('show');
        });
    }

    parseParams(query: string) {
        var re = /([^&=]+)=?([^&]*)/g;
        var decode = function (str: string) {
            return decodeURIComponent(str.replace(/\+/g, ' '));
        };
        var params: any = {}, e;
        if (query) {
            if (query.substr(0, 1) == '?') {
                query = query.substr(1);
            }

            while (e = re.exec(query)) {
                var k = decode(e[1]);
                var v = decode(e[2]);
                if (params[k] !== undefined) {
                    if (!$.isArray(params[k])) {
                        params[k] = [params[k]];
                    }
                    params[k].push(v);
                } else {
                    params[k] = v;
                }
            }
        }
        return params;
    };


    listenChangeCurrency() {
        let self = this;
        $(document).on('click', 'span.currency', 'click', function (event) {
            let currency = $(this).attr('data-value')!;
            self.utils.createCookie('currency', currency, 30, Domain);
            let urlParams = self.parseParams(window.location.search);
            if (urlParams.currency != undefined) {
                urlParams.currency = currency;
                window.location.assign('?' + $.param(urlParams))
            }
            else {
                window.location.reload()
            }
        });
    }

    listenLogin() {
        let self = this;
        $(document).on('submit', '#form-login, #form-login-error, #form-login-modal', function (event) {
            event.stopPropagation();
            event.preventDefault();
            let args = {
                alias: $(this).find('[name="alias"]').val(),
                password: $(this).find('[name="password"]').val(),
                code_2fa: $(this).find('[name="code_2fa"]').val()
            }
                , config = { dir: '/action/login/', type: 'POST' }
                , $form = $(this)

            let $btn_accion = $form.find('#btn-login');

            self.addLoadingButton($btn_accion)

            self.utils.jSONInfo(config, args, function (data: any) {
                if (data.ans?.error === 10 || data.ans?.errSTR === "Auth 2FA") {
                    $("#code_2fa").removeClass("d-none");
                }
                setTimeout(function () {
                    self.removeLoadingButton($btn_accion)
                }, 300)
                self.utils.afterSubmit(data, $form.attr('id'), false)
            });
        });
    }

    listenGetLinkAlq() {
        let self = this;
        $(document).on('submit', '#form-get-link-alq', function (this: HTMLFormElement, event) {
            event.stopPropagation();
            event.preventDefault();

            let $form = $(this),
                attr = $form.serializeArray();

            // Convertir el objeto en un objeto clave-valor
            var formObject: any = {};
            $.each(attr, function (index, field) {
                formObject[field.name] = field.value;
            });

            if (formObject['g-recaptcha-response'] == '') {
                return false;
            }

            let config = { dir: '/action/get-link-alq/', type: 'POST' };

            let $btn_accion = $form.find('#btn-get-link-alq');

            self.addLoadingButton($btn_accion)

            self.utils.jSONInfo(config, formObject, function (data: any) {
                setTimeout(function () {
                    self.removeLoadingButton($btn_accion);
                }, 300)
                self.utils.afterSubmit(data, $form.attr('id'), false);
                self.grecaptchaReset();
            });
        });
    }



    addLoadingButton($btn_action: JQuery<HTMLElement>, text?: string) {
        $btn_action.addClass('disabled');
        let text_org = $btn_action.text();
        $btn_action.data('btn-text', text_org);
        // Crear el elemento HTML del spinner
        let spinner = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>`;
        // Combinar el texto original con el spinner
        let textoConSpinner = `${spinner} ${text || text_org}`;
        // Establecer el nuevo contenido del botón
        $btn_action.html(textoConSpinner);
    }

    removeLoadingButton($btn_action: JQuery<HTMLElement>, text?: string) {
        $btn_action.removeClass('disabled');
        let text_org = $btn_action.data('btn-text');
        $btn_action.html(text || text_org);
    }


    submitRegistrarUsuario() {
        let self = this;
        $('#form-reg-usuario').on('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let $this: any = $(this);
            let $btn_accion = $this.find('.btn-accion')

            if ($btn_accion.hasClass('desactivar')) {
                return false
            }

            if (!self.validarDatosUsuario()) {
                return false
            }

            let attr = $this.serializeArray();

            // Convertir el objeto en un objeto clave-valor
            var formObject: any = {};
            $.each(attr, function (index, field) {
                formObject[field.name] = field.value;
            });

            self.addLoadingButton($btn_accion);

            let config = { dir: $this.attr('action'), type: $this.attr('method') };

            if (formObject['g-recaptcha-response'] == '') {
                return false;
            }

            self.utils.jSONInfo(config, formObject, function (data: any) {
                self.grecaptchaReset();
                self.removeLoadingButton($btn_accion);

                // Si hay un error reportado por el backend o el status no es exitoso
                if (data.status?.error || !data.user_data?.status) {
                    let errorMessage = data.mensaje;
                    if (!errorMessage && data.user_data?.errSTR) {
                        errorMessage = [data.user_data.errSTR];
                    }

                    data.status = data.status || { error: true };
                    data.mensaje = errorMessage || ['Error al registrar usuario'];

                    self.utils.afterSubmit(data, 'form-reg-usuario', function () {
                        self.utils.closeMsjModal()
                    });
                } else {
                    data.mensaje = data.mensaje || ['Usuario creado exitosamente, Inicia sesión'];
                    data.status.close = true;
                    self.utils.afterSubmit(data, 'form-reg-usuario', function () {
                        self.utils.closeMsjModal();
                        $this[0].reset()
                        setTimeout(() => {
                            $('#modal-login').modal('show');
                        }, 400)
                    });
                }
            });
        });
    }

    validarDatosUsuario() {
        let forms = new Forms();
        const camposAValidar: any = [
            { id: 'user-name', validaciones: ['required',] },
            { id: 'user-lastname', validaciones: ['required'] },
            { id: 'user-email', validaciones: ['required'] },
            { id: 'user-password', validaciones: ['required'] },
        ];

        const formularioEsValido = forms.validarCampos('form-reg-usuario', camposAValidar);
        return formularioEsValido
    }

    ForgotListen() {
        let self = this;
        $('#form-forgot').on('submit', function (e) {
            e.preventDefault()

            let $this = $(this),
                $btn_accion = $this.find('.btn-accion'),
                $form = $(this)

            if ($btn_accion.hasClass('desactivar')) {
                return false
            }

            if (!self.validarDatosForgot()) {
                return false
            }

            let textoOriginal = $btn_accion.text();

            self.addLoadingButton($btn_accion, textoOriginal)

            $btn_accion.addClass('disabled');

            let attr = self.serializeObjetc($form),
                config = { dir: $form.attr('action'), type: $form.attr('method') };
            self.utils.jSONInfo(config, attr, function (data: any) {
                self.utils.afterSubmit(data, 'form-forgot', function () {
                    setTimeout(function () { self.utils.closeMsjModal(); }, 1000);
                })
                $btn_accion.removeClass('disabled').html(x_textos['T90-0'])
            });
        });
    }

    validarDatosForgot() {
        let forms = new Forms();
        const camposAValidar: any = [
            { id: 'forgot-email', validaciones: ['required', 'email'] },
        ];

        const formularioEsValido = forms.validarCampos('form-forgot', camposAValidar);
        return formularioEsValido
    }

    getParams(param?: string) {
        const urlParams = new URLSearchParams(window.location.search);
        if (!param) {
            const params: { [key: string]: string } = {};
            urlParams.forEach((value, key) => {
                params[key] = value;
            });
            return params;
        } else {
            return urlParams.get(param);
        }
    }

    deleteParams(param?: string) {
        const url = new URL(window.location.href);
        if (param) {
            url.searchParams.delete(param);
        } else {
            url.search = '';
        }
        window.history.replaceState({}, '', url.toString());
    }

    serializeObjetc($form: any) {
        let attr = $form.serializeArray();

        // Convertir el objeto en un objeto clave-valor
        var formObject: any = {};
        $.each(attr, function (index, field) {
            formObject[field.name] = field.value;
        });

        formObject['csrf_token'] = this.utils.getCsrfToken();  // Agrega el token CSRF a los datos

        return formObject;
    }

    listenCookies() {
        let self = this;
        const cookieValue = '1';//self.utils.readCookie('aceptar_cookies');
        if (!cookieValue || cookieValue !== '1') {
            // Ocultar el banner simple por si está visible
            $('#cookies').css('display', 'none');
            setTimeout(() => {
                const modalElement = document.getElementById('cookieConsentModal');
                if (modalElement) {
                    import('bootstrap/js/dist/modal').then((module) => {
                        const Modal = (module as any).default || module;
                        const cookieModal = new Modal(modalElement, {
                            backdrop: 'static',
                            keyboard: false
                        });
                        cookieModal.show();
                    });
                    return;
                }
            }, 60000);
        }
        $("#aceptar-todas-cookies").on('click', function (event) {
            event.stopPropagation();
            event.preventDefault();

            self.utils.createCookie('aceptar_cookies', "1", 365, Domain);
            const modalElement = document.getElementById('cookieConsentModal');
            if (modalElement) {
                let cookieModal = null;

                if ((window as any).bootstrap && (window as any).bootstrap.Modal) {
                    cookieModal = (window as any).bootstrap.Modal.getInstance(modalElement);
                } else if ((window as any).Modal) {
                    cookieModal = (window as any).Modal.getInstance(modalElement);
                }
                if (cookieModal) {
                    cookieModal.hide();
                } else {
                    $(modalElement).modal('hide');
                }
            }
            window.location.reload();
        });

        $("#rechazar-todas-cookies").on('click', function (event) {
            event.stopPropagation();
            event.preventDefault();

            self.utils.createCookie('aceptar_cookies', "0", 365, Domain);

            const modalElement = document.getElementById('cookieConsentModal');
            if (modalElement) {
                let cookieModal = null;

                if ((window as any).bootstrap && (window as any).bootstrap.Modal) {
                    cookieModal = (window as any).bootstrap.Modal.getInstance(modalElement);
                } else if ((window as any).Modal) {
                    cookieModal = (window as any).Modal.getInstance(modalElement);
                }
                if (cookieModal) {
                    cookieModal.hide();
                } else {
                    $(modalElement).modal('hide');
                }
            }
        });
        $("#aceptar-cookies").on('click', function (event) {
            event.stopPropagation();
            event.preventDefault();
            self.utils.createCookie('aceptar_cookies', "1", 365, Domain);
            $('#cookies').css('display', 'none');
            window.location.reload();
        });
    }

    grecaptchaReset() {
        if (typeof grecaptcha !== 'undefined') {
            const captchas = $('.g-recaptcha');
            for (let i = 0; i < captchas.length; i++) {
                grecaptcha.reset(i);
            }
        }
    }

    addTooltip() {
        $('.tooltip.bs-tooltip-auto').remove();
        $('[data-tooltip]').each(function () {
            $(this).tooltip({ title: $(this).data('tooltip'), customClass: 'tooltip-custom' });
        });
    }
}

export function waitLangText(callback: Function) {
    if (typeof x_textos !== 'undefined' && x_textos !== undefined) {
        callback();
    } else {
        setTimeout(() => waitLangText(callback), 100);
    }
}